import React, { useState, useEffect, useContext } from 'react'
import { Tooltip } from '@mui/material'
import { BufferService, LoadingContext, M_CheckBox, M_InputTextField, M_DrawerTableTextField, M_StateActions, NavigateContext } from 'src/components/M_Components'
import TableCostsCustomer from 'src/components/utils/tableCostsCustomer'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import './formsTable.css'

export default function CreateCustomer() {
    const dispatch = useDispatch()
    const M_State = useSelector((state) => state.StateKeyValue)
    const [id, setId] = useState(M_State.filter(obj => obj.key === 'selectedTab')[0]?.value)
    const [dataCustomers, setDataCustomers] = useState(new Map())
    const [optionsCustomer, setOptionsCustomer] = useState([])
    const [rowCost, setRowCost] = useState([])
    const [isFirstLoop, setIsFirstLoop] = useState(true)
    const [customerId, setCustomerId] = useState("")
    const [operation, setOperation] = useState("")
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)
    const bufferServiceCustomers = new BufferService('Customer')
    const { t } = useTranslation()

    const sessionKeys = ['dataCustomers', 'optionsCustomer', 'rowCost', 'customerId', 'operation']

    useEffect(() => {
        if (isFirstLoop) {
            ctx.setIsLoad(true)
            getSessionStorageData(id)
            setIsFirstLoop(false)
        }
        // eslint-disable-next-line 
    }, [])

    // eslint-disable-next-line 
    useEffect(() => {
        const newId = M_State.filter(obj => obj.key === 'selectedTab')[0]?.value
        if (newId !== id) {
            setId(newId)
            getSessionStorageData(newId)
        }
    })

    useEffect(() => {
        const tempArray = []
        sessionKeys.forEach((key) => {
            tempArray.push(sessionStorageMachine(id, key, key))
        })
        dispatch(M_StateActions.addM_State({ key: id, value: tempArray }))
        // eslint-disable-next-line
    }, [id, dataCustomers, optionsCustomer, rowCost, customerId, operation])

    const sessionStorageMachine = (id, key, value) => {
        let tempObj = {}
        // eslint-disable-next-line
        if (eval(value) instanceof Map) {
            // eslint-disable-next-line
            tempObj = { key: `${key}`, value: (Array.from(eval(value))) }
        } else {
            // eslint-disable-next-line
            tempObj = { key: `${key}`, value: (eval(value)) }
        }
        return tempObj
    }

    const getSessionStorageData = (sessionID) => {
        ctx.setIsLoad(true)
        const M_StateData = M_State.filter(obj => obj.key === sessionID)[0]?.value
        if (M_StateData) {
            const tempDC = M_StateData.filter(obj => obj.key === `dataCustomers`)[0]?.value
            const tempOC = M_StateData.filter(obj => obj.key === `optionsCustomer`)[0]?.value
            const tempRC = M_StateData.filter(obj => obj.key === `rowCost`)[0]?.value
            const tempCI = M_StateData.filter(obj => obj.key === `customerId`)[0]?.value
            const tempOP = M_StateData.filter(obj => obj.key === `operation`)[0]?.value
            if (tempDC || tempOC || tempRC || tempCI || tempOP) {
                setDataCustomers(new Map(tempDC))
                setOptionsCustomer(tempOC)
                setRowCost(tempRC)
                setCustomerId(tempCI)
                setOperation(tempOP)
                ctx.setIsLoad(false)
                return
            }
        }
        getCustomer()
    }

    const getCustomer = () => {
        const getOperation = ctx.passValue.get('operation')
        const lines = ctx.passValue?.get('lines') || ""
        const getId = lines.Id
        ctx.passValue.delete('operation')
        ctx.passValue.delete('lines')
        ctx.setPassValue(new Map(ctx.passValue))
        setOperation(getOperation)
        setCustomerId(getId)

        bufferServiceCustomers.options().then((responseOptions) => {
            if (responseOptions.name === 'AxiosError') {
                ctx.toastMessages('error', responseOptions.response.data.Errors[0], '')
                return
            }
            const filteredOptions = responseOptions.filter((option) => !option.IsHiddenEdit)
            setOptionsCustomer(filteredOptions)

            if (getOperation === 'edit') {
                bufferServiceCustomers.getId(getId).then((response) => {
                    if (response.name === 'AxiosError') {
                        ctx.toastMessages('error', response.response.data.Errors[0], '')
                        ctx2.closeTab(id)
                        return
                    }
                    const valueDataCustomer = response
                    setRowCost(valueDataCustomer['ExtraCostsList'])
                    const tempMap = new Map()

                    Object.keys(valueDataCustomer).forEach(key => {
                        tempMap.set(key, valueDataCustomer[key])
                    })

                    setDataCustomers(tempMap)
                    // setDataCustomers(new Map(dataCustomers))
                })
            }
        })
        ctx.setIsLoad(false)
    }

    const customerStructure = (event, index) => {
        if (event.type === "date") {
            const dateValue = new Date(event).toISOString().split("T")[0]
            dataCustomers.set(index, dateValue)
        } else {
            dataCustomers.set(index, event)
        }
        setDataCustomers(new Map(dataCustomers))
    }

    const submitCustomer = () => {
        const requiredFieldsCustomer = optionsCustomer.filter((elem) => elem.IsRequired)
        for (const field of requiredFieldsCustomer) {
            if (!dataCustomers.has(field.Name) || !dataCustomers.get(field.Name)) {
                ctx.toastMessages('error', field.NormalizedName, t("RequiredField"))
                return
            }
        }
        ctx.setIsLoad(true)
        dataCustomers.set("ExtraCostsList", rowCost)
        setDataCustomers(new Map(dataCustomers))
        if (operation === 'edit') {
            bufferServiceCustomers.update(customerId, Object.fromEntries(dataCustomers)).then((response) => {
                if (response.name === 'AxiosError') {
                    ctx.setIsLoad(false)
                    ctx.toastMessages("error", '', t("ErrorUpdate"))
                    return
                }
                ctx.setIsLoad(false)
                ctx.toastMessages("success", '', t("SuccessUpdate"))
                ctx2.closeTab(id)
            })
        } else {
            bufferServiceCustomers.post(Object.fromEntries(dataCustomers)).then((response) => {
                if (response.name === 'AxiosError') {
                    ctx.setIsLoad(false)
                    ctx.toastMessages("error", '', t("ErrorCreate"))
                    return
                }
                ctx.setIsLoad(false)
                ctx.toastMessages("success", '', t("SuccessCreate"))
                ctx2.closeTab(id)
            })
        }
    }

    return (
        <div>
            <div className="display backgroundForms">
                <div className="menuIcon">
                    <Tooltip title={t("Close")} className='iconsHeaderTable'>
                        <div className='iconsHeaderTable' onClick={() => ctx2.closeTab(id)}>
                            <i className="pi pi-arrow-left iconTable"></i>
                            <span className='labelCRUDTable'><b>{t("Close")}</b></span>
                        </div>
                    </Tooltip>
                    <Tooltip title={t("Save")}>
                        <div className='iconsHeaderTable' onClick={submitCustomer}>
                            <i className="pi pi-save iconTable"></i>
                            <span className='labelCRUDTable'><b>{t("Save")}</b></span>
                        </div>
                    </Tooltip>
                </div>
            </div>
            <div className='divPrincipalFormTables'>
                <div className='divPrincipalFormCustomer'>
                    <div className='divFormInterior'>
                        <div className='divLabelName'>{t("Customer")}</div>
                        <div className='alignTextfieldsForm'>
                            {optionsCustomer.filter((elem) => elem.GroupByInfo === 'Customer').map((elem) => (
                                <div key={elem.Name}>
                                    {elem.Type === 'string' ? (
                                        elem.IsForeignKey ? (
                                            <M_DrawerTableTextField
                                                tableLabel={elem.NormalizedName}
                                                label={elem.NormalizedName}
                                                required={elem.IsRequired}
                                                entity={elem.ForeignTableName}
                                                value={dataCustomers.get(elem.ForeignTableToPassId) ?
                                                    {
                                                        [elem.ForeignTableToPassId]: dataCustomers.get(elem.ForeignTableToPassId),
                                                        [elem.ForeignKeyName]: dataCustomers.get(elem.Name)
                                                    } : null}
                                                filterField={elem.ForeignKeyName}
                                                labelFields={[elem.ForeignKeyName]}
                                                onSubmitValue={obj => {
                                                    if (obj) {
                                                        dataCustomers.set(elem.Name, obj[elem.ForeignKeyName])
                                                        dataCustomers.set(elem.ForeignTableToPassId, obj[elem.ForeignTableToPassId])
                                                    } else {
                                                        dataCustomers.set(elem.Name, null)
                                                        dataCustomers.set(elem.ForeignTableToPassId, null)
                                                    }
                                                    setDataCustomers(new Map(dataCustomers))
                                                }}
                                                disabled={elem.disable}
                                            // valueField={elem.ForeignTableToPassId}
                                            />
                                        ) :
                                            <M_InputTextField
                                                type={"text"}
                                                label={elem.NormalizedName}
                                                secondColor={"var(--color-red-dark)"}
                                                required={elem.IsRequired}
                                                onChange={(e) => customerStructure(e.target.value, elem.Name)}
                                                value={dataCustomers.get(elem.Name) || ""}
                                            />

                                    ) : elem.Type === 'int32' ? (
                                        <M_InputTextField
                                            type={"number"}
                                            label={elem.NormalizedName}
                                            secondColor={"var(--color-red-dark)"}
                                            required={elem.IsRequired}
                                            onChange={(e) => customerStructure(e.target.value, elem.Name)}
                                            value={dataCustomers.get(elem.Name) || ""}
                                        />
                                    ) : elem.Type === 'boolean' ? (
                                        <div className='divCheckboxFormQuotes'>
                                            <M_CheckBox
                                                label={elem.NormalizedName}
                                                onChange={(e) => customerStructure(e.target.checked, elem.Name)}
                                                color={"var(--color-red-dark)"}
                                                checked={dataCustomers.get(elem.Name) || false}
                                            />
                                        </div>
                                    ) : null}

                                </div>
                            ))}
                        </div>
                    </div>
                    <div className='divFormInterior'>
                        <div className='divLabelName'>Email</div>
                        <div className='alignTextfieldsForm'>
                            {optionsCustomer.filter((elem) => elem.GroupByInfo === 'Email').map((elem) => (
                                <div key={elem.Name}>
                                    {elem.Type === 'string' ? (
                                        <M_InputTextField
                                            type={"text"}
                                            label={elem.NormalizedName}
                                            secondColor={"var(--color-red-dark)"}
                                            required={elem.IsRequired}
                                            onChange={(e) => customerStructure(e.target.value, elem.Name)}
                                            value={dataCustomers.get(elem.Name) || ""}
                                        />

                                    ) : elem.Type === 'int32' ? (
                                        <M_InputTextField
                                            type={"number"}
                                            label={elem.NormalizedName}
                                            secondColor={"var(--color-red-dark)"}
                                            required={elem.IsRequired}
                                            onChange={(e) => customerStructure(e.target.value, elem.Name)}
                                            value={dataCustomers.get(elem.Name) || ""}
                                        />
                                    ) : elem.Type === 'boolean' ? (
                                        <div className='divCheckboxFormQuotes'>
                                            <M_CheckBox
                                                label={elem.NormalizedName}
                                                onChange={(e) => customerStructure(e.target.checked, elem.Name)}
                                                color={"var(--color-red-dark)"}
                                                checked={dataCustomers.get(elem.Name) || false}
                                            />
                                        </div>
                                    ) : null}
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className='divFormInterior'>
                        <div className='divLabelName'>{t("Address")} </div>
                        <div className='alignTextfieldsForm'>
                            {optionsCustomer.filter((elem) => elem.GroupByInfo === 'Address').map((elem) => (
                                <div key={elem.Name}>
                                    {elem.Type === 'string' ? (
                                        elem.IsForeignKey ? (
                                            <M_DrawerTableTextField
                                                tableLabel={elem.NormalizedName}
                                                label={elem.NormalizedName}
                                                required={elem.IsRequired}
                                                entity={elem.ForeignTableName}

                                                value={dataCustomers.get(elem.ForeignTableCurrentId) ?
                                                    {
                                                        [elem.ForeignKeyName]: dataCustomers.get(elem.Name),
                                                        [operation === 'edit' ? elem.ForeignTableCurrentId : elem.ForeignTableToPassId]: dataCustomers.get(
                                                            operation === 'edit' ? elem.ForeignTableCurrentId : elem.ForeignTableToPassId
                                                        )
                                                    } : null}
                                                filterField={elem.ForeignKeyName}
                                                labelFields={[elem.ForeignKeyName]}
                                                onSubmitValue={obj => {
                                                    if (obj) {
                                                        dataCustomers.set(elem.Name, obj[elem.ForeignKeyName])
                                                        dataCustomers.set(elem.ForeignTableToPassId, obj[elem.ForeignTableToPassId])
                                                    } else {
                                                        dataCustomers.set(elem.Name, null)
                                                        dataCustomers.set(elem.ForeignTableToPassId, null)
                                                    }
                                                    setDataCustomers(new Map(dataCustomers))
                                                }}
                                                disabled={elem.disable}
                                                valueField={elem.ForeignTableToPassId}
                                            />
                                        ) :
                                            <M_InputTextField
                                                type={"text"}
                                                label={elem.NormalizedName}
                                                secondColor={"var(--color-red-dark)"}
                                                required={elem.IsRequired}
                                                onChange={(e) => customerStructure(e.target.value, elem.Name)}
                                                value={dataCustomers.get(elem.Name) || ""}
                                            />

                                    ) : elem.Type === 'int32' ? (
                                        <M_InputTextField
                                            type={"number"}
                                            label={elem.NormalizedName}
                                            secondColor={"var(--color-red-dark)"}
                                            required={elem.IsRequired}
                                            onChange={(e) => customerStructure(e.target.value, elem.Name)}
                                            value={dataCustomers.get(elem.Name) || ""}
                                        />
                                    ) : elem.Type === 'boolean' ? (
                                        <div className='divCheckboxFormQuotes'>
                                            <M_CheckBox
                                                label={elem.NormalizedName}
                                                onChange={(e) => customerStructure(e.target.checked, elem.Name)}
                                                color={"var(--color-red-dark)"}
                                                checked={dataCustomers.get(elem.Name) || false}
                                            />
                                        </div>
                                    ) : null}
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className='divFormInterior'>
                        <div className='divLabelName'>{t("Costs")}</div>
                        <div className='divTableCosts'>
                            <TableCostsCustomer rowCost={rowCost} setRowCost={setRowCost} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}